import _ from 'lodash';
import type { Block } from 'sanity-typed-queries';

export const isPortableTextBlock = <O extends any>(input: O | Block): input is Block => {
  if (
    _.get(input, '_type') === 'block'
    && !_.isNil(_.get(input, 'children'))
    && !_.isNil(_.get(input, 'markDefs'))
    && !_.isNil(_.get(input, 'style'))
  ) {
    return true;
  }
  return false;
}